import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@material-ui/styles';
import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import BaseLayout from 'layouts/BaseLayout';
import Commercial from 'pages/Commercial';
import Company from 'pages/Company';
import Copyright from 'pages/Copyright';
// import DeliveryFee from 'components/pages/DeliveryFee';
import Environment from 'pages/Environment';
import PrivacyPolicy from 'pages/PrivacyPolicy';
import PrivacyPolicyHTB from 'pages/PrivacyPolicyHTB';
import QandA from 'pages/QandA';
import Termsofuse from 'pages/Termsofuse';
import Index from 'pages/index';
import theme from 'stylesheet';

export const apolloClient = new ApolloClient({
  uri: `https://${
    process.env.REACT_APP_SHOPIFY_SHOP_DOMAIN ?? ''
  }/api/2021-01/graphql.json`,
  headers: {
    'X-Shopify-Storefront-Access-Token':
      process.env.REACT_APP_SHOPIFY_STORE_FRONT_ACCESS_TOKEN ?? '',
  },
  cache: new InMemoryCache(),
});

const App: FC = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <BaseLayout>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/QandA" element={<QandA />} />
              <Route path="/Company" element={<Company />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/PrivacyPolicyHTB" element={<PrivacyPolicyHTB />} />
              <Route path="/Termsofuse" element={<Termsofuse />} />
              <Route path="/Environment" element={<Environment />} />
              {/* <Route path="/DeliveryFee" element={<DeliveryFee />} /> */}
              <Route path="/Copyright" element={<Copyright />} />
              <Route path="/Commercial" element={<Commercial />} />
              <Route path="/*" element={<Navigate to="/" />} />
            </Routes>
          </BaseLayout>
        </BrowserRouter>
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default App;
